import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Avatar, Box, Grid } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LeadService from '../../core/services/leadsService';
import toast from 'react-hot-toast';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import PaymentsIcon from '@mui/icons-material/Payments';
import UnsubscribeIcon from '@mui/icons-material/Unsubscribe';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
const SuperAdmin_Cards = () => {
    const [CountAgents, setCountAgents] = React.useState('');
    const GetCountAgent = async () => {
        try {
            const resp = await LeadService.CountAgentAndCustomer();
            if (resp?.data?.success) {
                // toast.success(resp?.data?.message);
                setCountAgents(resp?.data);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    useEffect(() => {
        GetCountAgent();
    }, []);
    const iconMap = {
        'Total No Of  All Agent': <AccountCircleIcon style={{ color: '#3674c4',  fontSize: '35px', }} />,
        'Total No Of Self Sign Up Agent': <TouchAppIcon style={{ color: '#3674c4',  fontSize: '35px', }} />,
        'Total No Of System Generated Agent': <SettingsSuggestIcon style={{ color: '#3674c4',  fontSize: '35px', }} />,
        'Total No Of Active ( logged in) Users': <LoginIcon style={{ color: '#3674c4',  fontSize: '35px',}} />,
        'Total No Of Free Agents': <PersonRemoveIcon style={{ color: '#3674c4',  fontSize: '35px', }} />,
        'Total No Of Unsubscribe Agents': <UnsubscribeIcon style={{ color: '#3674c4',  fontSize: '35px', }} />,
        'Total No Of Monthly Paying Agents': <PaymentsIcon style={{ color: '#3674c4',  fontSize: '35px', }} />,
        'Total No Of All Paying Agents': <AccountBalanceWalletIcon style={{ color: '#3674c4',  fontSize: '35px', }} />,
    };
    return (
        <div>
            <Grid container spacing={2}>
                {[
                    { label: 'Total No Of  All Agent', value: CountAgents?.totalAgents },
                    { label: 'Total No Of Self Sign Up Agent', value: CountAgents?.totalSelfAgents },
                    { label: 'Total No Of System Generated Agent', value: CountAgents?.totalSystemAgents },
                    { label: 'Total No Of Active ( logged in) Users', value: CountAgents?.totalActiveAgents },
                    { label: 'Total No Of Free Agents', value: CountAgents?.totalFreeAgents },
                    { label: 'Total No Of Unsubscribe Agents', value: CountAgents?.totalUnsubscribeAgents },
                    { label: 'Total No Of Monthly Paying Agents', value: CountAgents?.totalMonthlyPayingAgents },
                    { label: 'Total No Of All Paying Agents', value: CountAgents?.totalAllPayingAgents},
                ]?.map((item, index) => (
                    <Grid item xs={12} sm={3} md={3} lg={3} key={index}>
                        <Card
                            sx={{
                                borderRadius: '20px',
                                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                background: 'linear-gradient(#26c7f3, #316ec1)',
                            }}
                        >
                            <CardContent>
                                <Box style={{ padding: '15px' }}>
                                    <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Avatar
                                            sx={{
                                                bgcolor:'#fff',
                                                width: { xs: '30px', sm: '50px', md:'50px', lg:'60px' },
                                                height: { xs: '30px', sm: '50px', md:'50px', lg:'60px' },
                                            }}
                                        >
                                            {iconMap[item?.label]}
                                        </Avatar>
                                        <Typography
                                            sx={{
                                                fontSize: { xs: '20px', sm: '24px' }, // Responsive font sizes
                                                fontWeight: 'bold',
                                                color: 'white',
                                                fontFamily: 'inherit',
                                            }}
                                        >
                                            {item?.value}
                                        </Typography>
                                    </Box>
                                    <Box style={{ marginTop: '20px' }}>
                                        <Typography sx={{ fontSize: { xs: '10px', sm: '12px', md: '14px' }, color: 'white' ,fontWeight: 'bold', fontFamily: 'inherit',}}>{item?.label}</Typography>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};

export default SuperAdmin_Cards;
